import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $container: this.el._$('.video-row__inner'),
      $play: this.el._$('.video-row__play')
    };
  }

  addListeners() {
    this.dom.$play._on('click', this.renderVideo.bind(this));
  }

  renderVideo() {
    const id = this.el.dataset.videoId;
    const iframe = document.createElement('iframe');
    iframe.setAttribute('allowfullscreen', '');
    iframe.src = `https://fast.wistia.com/embed/iframe/${id}?autoPlay=true`;
    this.dom.$container.append(iframe);
  }
}

export default Module;
